import { useState } from "react";
import { foApi } from "@/webapp/fleet-owners/api";
import { errorText } from "@/lib/api";
import { PageHead, Panel, Label, Field, Button, Notice } from "@/webapp/fleet-owners/ui";

export default function Company({ data, reload }) {
  const [form, setForm] = useState({ company: data.company, home_base: data.home_base });
  const [msg, setMsg] = useState(null);
  const save = async () => {
    setMsg(null);
    try { await foApi.saveSettings(form); await reload(); setMsg({ ok: true, text: "Saved." }); } catch (e) { setMsg({ ok: false, text: errorText(e) }); }
  };
  return (
    <>
      <PageHead eyebrow="System" title="Company" sub="How your fleet appears to site operators when you book." />
      <Panel className="fo-rise fo-rise-1 max-w-xl space-y-4 p-6" testid="fo-company-form">
        <div><Label>Company name</Label><Field data-testid="fo-company-name" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} /></div>
        <div><Label>Home base</Label><Field data-testid="fo-company-base" value={form.home_base} onChange={(e) => setForm({ ...form, home_base: e.target.value })} placeholder="Calgary, AB" /></div>
        {msg && <Notice tone={msg.ok ? "ok" : "error"} testid="fo-company-msg">{msg.text}</Notice>}
        <Button variant="primary" testid="fo-company-save" onClick={save}>Save</Button>
      </Panel>
    </>
  );
}
